import { IDefaultSidebarGroup } from '@/components/Layouts/EpkSidebar/types';
import { useRoutes } from '@/shared/routes';

export default (hasRightWrite = false) => {
  const routes: IDefaultSidebarGroup[] = [
    {
      title: 'Похозяйственные книги',
      icon: 'books',
      to: { name: useRoutes.EPK_LIST_NAME },
      path: useRoutes.EPK_LIST_PATH,
    },
  ];

  routes.push({
    title: 'Реестр \n лицевых счетов',
    icon: 'registry',
    to: { name: useRoutes.ACCOUNT_LIST_NAME },
    path: useRoutes.ACCOUNT_LIST_PATH,
  });

  if (hasRightWrite) {
    routes.push({
      title: 'Реестр глав ЛПХ',
      icon: 'team',
      to: { name: useRoutes.HEAD_LIST_NAME },
      path: useRoutes.HEAD_LIST_PATH,
    });

    routes.push({
      title: 'Карточки ЛПХ',
      icon: 'cards',
      to: { name: useRoutes.LPH_LIST_NAME },
      path: useRoutes.LPH_LIST_PATH,
    });
  }
  if (hasRightWrite) {
    routes.push({
      title: 'Сводные книги',
      icon: 'summary-books',
      to: {
        name: useRoutes.EPK_REPORT_LIST_NAME,
        query: { period: '1' },
      },
      path: useRoutes.EPK_REPORT_LIST_PATH,
    });
  }
  routes.push({
    title: 'Агрегированные данные',
    icon: 'aggregated-books',
    to: { name: useRoutes.AGG_REPORT_LIST_NAME },
    path: useRoutes.AGG_REPORT_LIST_PATH,
  });

  if (hasRightWrite) {
    routes.push({
      title: 'Выписки',
      icon: 'statement',
      to: { name: useRoutes.EXTRACT_LIST_NAME },
      path: useRoutes.EXTRACT_LIST_PATH,
    });
  }

  if (hasRightWrite) {
    routes.push({
      title: 'Запросы с ЕПГУ',
      icon: 'gos',
      to: { name: useRoutes.EPGU_LIST_NAME },
      path: useRoutes.EPGU_LIST_PATH,
    });
  }

  routes.push({
    title: 'Права доступа',
    icon: 'policy',
    to: { name: useRoutes.ACCESS_LIST_NAME },
    path: useRoutes.ACCESS_LIST_PATH,
  });

  routes.push({
    title: 'Организации',
    icon: 'organization',
    to: { name: useRoutes.ORG_LIST_NAME },
    path: useRoutes.ORG_LIST_PATH,
  });

  return routes;
};
